module.exports = __webpack_public_path__ + "images/emoji/chart.eb6f7d9aeec0c83fbcad.png";